module.exports = __webpack_public_path__ + "static/media/chevron-compact-left.090a5934.svg";